import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Container, Row, Col, Card, Button, Form, Pagination } from 'react-bootstrap';
import { Link, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
//import RecipeForm from './RecipeForm';
import { FaClock, FaUser, FaTachometerAlt } from 'react-icons/fa';
import { Recipe } from './tipos/Recipe';

const RecipeSearch: React.FC = () => {
  const [keyword, setKeyword] = useState('');
  const [recipes, setRecipes] = useState<Recipe[]>([]);
  // const [selectedRecipeId, setSelectedRecipeId] = useState<number | null>(null);
  // const [isAddingRecipe, setIsAddingRecipe] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [recipesPerPage] = useState(36);
  const navigate = useNavigate();

  const { t } = useTranslation();

  const fetchRecipes = async () => {
    try {
      const response = await axios.get<Recipe[]>(`https://rednext31.ddns.net:3005/api/recipes${keyword ? `?keyword=${keyword}` : ''}`);
      setRecipes(response.data);
    } catch (error) {
      console.error('Error fetching recipes:', error);
    }
  };

  useEffect(() => {
    fetchRecipes();
  }, [keyword]);


  // const PlaceholderSVG = () => (
  //   <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%">
  //     <rect width="100%" height="100%" fill="#ddd" />
  //     <text x="50%" y="50%" fontSize="24" fill="#aaa" dy=".3em" textAnchor="middle">Placeholder</text>
  //   </svg>
  // );

  const placeholderSVG = `
  <svg xmlns="http://www.w3.org/2000/svg" width="400" height="250">
    <rect width="100%" height="100%" fill="#ddd" />
    <text x="50%" y="50%" font-size="24" fill="#aaa" dy=".3em" text-anchor="middle">Sin Imagen</text>
  </svg>
`;


  // const handleRecipeSubmit = async (recipe: Partial<Recipe>) => {
  //   try {
  //     if (selectedRecipeId) {
  //       await axios.put(`https://rednext31.ddns.net:3005/api/recipes/${selectedRecipeId}`, recipe);
  //     } else {
  //       await axios.post('https://rednext31.ddns.net:3005/api/recipes', recipe);
  //     }
  //     fetchRecipes();
  //     setSelectedRecipeId(null);
  //     setIsAddingRecipe(false);
  //   } catch (error) {
  //     console.error('Error saving recipe:', error);
  //   }
  // };

  const handleDelete = async (id: number) => {
    if (window.confirm(t('recipe.confirmDelete'))) {
      try {
        await axios.delete(`https://rednext31.ddns.net:3005/api/recipes/${id}`);
        fetchRecipes();
      } catch (error) {
        console.error('Error deleting recipe:', error);
      }
    }
  };
  
  const startAddingRecipe = () => {
    navigate('/recipe/new');
  };

  const startEditingRecipe = (id: number) => {
    navigate(`/recipe/edit/${id}`);
  };

  // const startAddingRecipe = () => {
  //   setSelectedRecipeId(null);
  //   setIsAddingRecipe(true);
  // };

  // const startEditingRecipe = (id: number) => {
  //   setSelectedRecipeId(id);
  //   setIsAddingRecipe(true);
  // };

  // Pagination
  const indexOfLastRecipe = currentPage * recipesPerPage;
  const indexOfFirstRecipe = indexOfLastRecipe - recipesPerPage;
  const currentRecipes = recipes.slice(indexOfFirstRecipe, indexOfLastRecipe);

  const paginate = (pageNumber: number) => setCurrentPage(pageNumber);

  return (
    <Container className="recipe-search-container">
      <h1 className="text-center my-4">{t('recipe.ourRecipes')}</h1>
      <Form className="mb-4">
        <Form.Control 
          type="search" 
          value={keyword} 
          onChange={(e) => setKeyword(e.target.value)} 
          placeholder={t('recipe.searchPlaceholder')} 
          className="form-control-lg"
        />

      </Form>

      <Button variant="outline-primary" onClick={startAddingRecipe} className="mb-4">{t('recipe.addNew')}</Button>

      <Row xs={1} md={2} lg={3} className="g-4">
        {currentRecipes.map((recipe) => (
          <Col key={recipe.id}>
            <Card className="h-100 recipe-card">
              <Card.Img variant="top" src={recipe.portada || `data:image/svg+xml;charset=utf-8,${encodeURIComponent(placeholderSVG)}`} alt={recipe.title} />
              <Card.Body>
                <Card.Title>{recipe.title}</Card.Title>
                <Card.Text>
                  <FaClock /> {recipe.cooktime} minutos <br />
                  <FaTachometerAlt /> {recipe.dificultad} <br />
                  <FaUser /> {recipe.raciones} raciones
                </Card.Text>
                <Link to={`/recipe/${recipe.id}`} className="btn btn-outline-primary me-2">{t('recipe.view')}</Link>
                <Button variant="outline-warning" className="me-2" onClick={() => startEditingRecipe(recipe.id)}>{t('recipe.edit')}</Button>
                <Button variant="outline-danger" onClick={() => handleDelete(recipe.id)}>{t('recipe.delete')}</Button>
              </Card.Body>
            </Card>
            
          </Col>
        ))}
      </Row>

      <Pagination className="mt-4 justify-content-center">
        {[...Array(Math.ceil(recipes.length / recipesPerPage))].map((_, index) => (
          <Pagination.Item key={index + 1} active={index + 1 === currentPage} onClick={() => paginate(index + 1)}>
            {index + 1}
          </Pagination.Item>
        ))}
      </Pagination>
    </Container>
  );
};

export default RecipeSearch;
